<template>
  <div class="share-info banner-wrap">
    <div class="row">
      <div class="input-field" style="margin-bottom:30px">
        <label :for="name"></label>
        <p>{{size}}</p>
        <div class="input-field">
          <input class="input-with-btn" :name="name" :id="name" :value='`<a href="${url}?mpc=${utm_medium}&utm_medium=${utm_medium}&utm_source=${utm_source}&utm_brand=${utm_brand}&utm_campaign=${utm_campaign}&utm_content=${size}" target="_blank" rel="dofollow"><img src="${imageUrl}" alt="Punkta.pl – porównywarka OC"></a>`' :type="type" readonly
                 @focus="select"/>
          <button type="submit" class="btn-flat btn-copy" @click="copyUrl">
            <img src="../../assets/copy-icon.svg">
          </button>

          <div class="row">
            <img class="banner-image" :src="imageUrl" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Materialize from 'materialize-css'
import { copyToClipboard } from '@/services/helper'
export default {
  props: ['type', 'name', 'label', 'imageUrl', 'utm_source', 'utm_medium', 'utm_brand', 'size', 'url', 'utm_campaign'],
  methods: {
    select (e) {
      e.target.select()
      this.text = e.target.value
      e.target.nextElementSibling.click()
    },
    copyUrl (e) {
      const text = this.text || e.target.previousElementSibling.value
      if (text && copyToClipboard(text)) {
        Materialize.toast('Skopiowano link banera', 2000)
      } else {
        Materialize.toast('Nie udało się skopiować linku', 1000)
      }
    }
  }
}
</script>

<style lang="scss" src="../inputs/input.scss"></style>



// WEBPACK FOOTER //
// bannerUrl.vue?2cb8475c